function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import PropTypes from "prop-types";
import { PiBank } from "react-icons/pi";
import classnames from "classnames";
function BrokerAvatar(_ref) {
  var size = _ref.size,
    broker = _ref.broker,
    className = _ref.className,
    style = _ref.style,
    onClick = _ref.onClick;
  var width, height, borderRadius, iconSize;
  if (size === "xs") {
    width = 25;
    height = 25;
    borderRadius = 3;
    iconSize = 20;
  } else if (size === "sm") {
    width = 33;
    height = 33;
    borderRadius = 6;
    iconSize = 22;
  } else if (size === "md") {
    width = 40;
    height = 40;
    borderRadius = 6;
    iconSize = 24;
  } else if (size === "lg") {
    width = 80;
    height = 80;
    borderRadius = 12;
    iconSize = 48;
  } else if (size === "xl") {
    width = 150;
    height = 150;
    borderRadius = 12;
    iconSize = 64;
  } else {
    throw new Error("Size not supported.");
  }
  return broker.picture ? /*#__PURE__*/React.createElement("img", {
    width: width,
    height: height,
    src: broker.picture.src,
    onError: function onError(e) {
      e.target.onerror = null;
      e.target.src = "/img/image_missing.png";
    },
    className: classnames("border", className),
    style: _objectSpread({
      borderRadius: borderRadius,
      objectFit: "cover"
    }, style),
    onClick: onClick
  }) : /*#__PURE__*/React.createElement("div", {
    className: classnames("d-flex", "justify-content-center", "align-items-center", "bg-gradient-brand-primary-to-pink", className),
    style: {
      width: width,
      height: height,
      borderRadius: borderRadius
    }
  }, /*#__PURE__*/React.createElement(PiBank, {
    color: "white",
    size: iconSize
  }));
}
export default BrokerAvatar;
BrokerAvatar.defaultProps = {
  size: "md"
};
BrokerAvatar.propTypes = {
  size: PropTypes.string,
  broker: PropTypes.object.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
};